export const scrollElementIntoView = (elementRef, parentRef) => {
  const { offsetHeight, offsetTop } = elementRef.current;
  const { offsetHeight: parentOffsetHeight } = elementRef.current.offsetParent;
  // eslint-disable-next-line no-param-reassign
  parentRef.current.scrollTop = offsetTop - parentOffsetHeight + offsetHeight;
};
